/**
 * Rótulos legíveis usados nas telas do Master (plano 19/10, item 4.20).
 */

/** Tipo de desconto gravado no atendimento -> nome para as análises. */
export const TIPO_DESCONTO_LBL = {
  fidelidade: "Fidelidade", cliente_novo: "Cliente Novo", sumido: "Sumido",
  // O motor grava 'frequencia'; 'frequente' fica para registros antigos.
  frequencia: "Frequência", frequente: "Frequente",
  promo_dia: "Promo do Dia", cashback: "Cashback",
  gamificacao: "Gamificação", alternados: "Alternados", oleo: "Óleo",
  saudade: "Saudade", aditivada_switch: "Aditivada (switch)", aditivada: "Aditivada",
  indicacao: "Indicação", recompensa: "Recompensa", grupo_consumo: "Grupo de Consumo",
  // Pedido de 19/10, Fase 2: prêmio do sorteio (uso único) e desconto progressivo (a partir de R$ Y).
  sorteio: "Prêmio do Sorteio", progressivo: "Progressivo",
  // Fase 3: Rota de Fidelização (desconto de cada etapa e prêmio em R$ ao concluir).
  rota_etapa_1: "Rota - Etapa 1", rota_etapa_2: "Rota - Etapa 2", rota_etapa_3: "Rota - Etapa 3",
  rota_premio: "Prêmio da Rota",
};

/**
 * Nome legível do tipo. Tipos compostos do calcular ('cashback+aditivada', 'frequencia+aditivada')
 * viram "Cashback + Aditivada". Tipo desconhecido aparece como veio (nunca some da tabela).
 */
export function rotuloTipoDesconto(tipo) {
  if (tipo == null || tipo === "") return "—";
  const partes = String(tipo).split("+").map((p) => p.trim()).filter(Boolean);
  if (!partes.length) return String(tipo);
  return partes.map((p) => TIPO_DESCONTO_LBL[p] || p).join(" + ");
}

/**
 * Código de indicação não usado e com validade vencida (antes aparecia como "disponível").
 * expira_em vem como texto ISO-8601; sem data de validade, não é tratado como expirado.
 */
export function codigoExpirado(c, agora = Date.now()) {
  if (!c || c.usado_por || !c.expira_em) return false;
  const t = new Date(String(c.expira_em).replace(" ", "T")).getTime();
  return Number.isFinite(t) && t < agora;
}
